import { useUser } from "@features/user-account/queries"
import { Badge, Group, List, Stack, Text } from "@mantine/core"
import { IconCircleDot } from "@tabler/icons-react"

export const EmailStep: React.FC = () => {

    const { data: user } = useUser()

    return (
        <Stack  gap="xl">
            <Group justify="center">
                <Badge 
                    color="blue" 
                    variant="light" 
                    size="lg"
                    tt="none"
                    radius="md"
                >
                    {user?.userPrincipalName}
                </Badge>
            </Group>
            <Text>
                We use Microsoft Outlook for our email service. You can access your email inbox in several ways:
            </Text>
            <List pl={'xl'} listStyleType="disc" withPadding spacing={"sm"}>
                <List.Item>On any web browser: www.outlook.com</List.Item>
                <List.Item>On your mobile phone or tablet using the Outlook app</List.Item>
                <List.Item>Add your College email to your device's mail app</List.Item>
                <List.Item>Using the Outlook desktop app on a College computer</List.Item>
                <List.Item>On the Student Portal</List.Item>
            </List>
            <Text>Your email address can be used to redeem most student discounts.</Text>
        </Stack>
    )
}